import React from 'react';
import { SvgSizeClassProps } from '../interfaces';

const SVGFightLose = ({ size = 332, className }: SvgSizeClassProps) => (
  <svg
    width={size}
    height={size * 0.54}
    viewBox='0 0 332 180'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M14.1318 75.403V162.088L70.6589 150.073V164.52L0 179.539V78.4068L14.1318 75.403Z'
      fill='#321E68'
    />
    <path
      d='M134.197 129.344L141.263 127.842V70.0517L134.197 71.5536V64.3299L105.933 70.3375V77.5612L98.8673 79.0631V136.853L105.933 135.351V142.575L134.197 136.567V129.344ZM148.329 54.1023V61.3261L155.394 59.8242V132.062L148.329 133.564V140.787L141.263 142.289V149.513L98.8673 158.524V151.301L91.8014 152.802V145.579L84.7355 147.081V74.8432L91.8014 73.3413V66.1175L98.8673 64.6156V57.3919L141.263 48.3805V55.6042L148.329 54.1023Z'
      fill='#321E68'
    />
    <path
      d='M233.064 36.0912V43.315L240.13 41.8131V56.2606L225.998 59.2644V52.0406L218.932 53.5425V46.3188L190.669 52.3264V59.5501L183.603 61.052V75.4995L190.669 73.9976V81.2214L225.998 73.7119V80.9356L233.064 79.4337V86.6575L240.13 85.1556V114.051L233.064 115.552V122.776L225.998 124.278V131.502L183.603 140.513V133.29L176.537 134.791V127.568L169.471 129.07V114.622L183.603 111.618V118.842L190.669 117.34V124.564L218.932 118.556V111.333L225.998 109.831V95.3831L218.932 96.885V89.6613L183.603 97.1708V89.947L176.537 91.4489V84.2252L169.471 85.7271V56.8321L176.537 55.3302V48.1064L183.603 46.6045V39.3808L225.998 30.3694V37.5931L233.064 36.0912Z'
      fill='#321E68'
    />
    <path
      d='M254.206 125.506V24.3735L324.865 9.35449V23.802L268.338 35.8172V64.7122L310.734 55.7008V70.1483L268.338 79.1597V108.055L324.865 96.0395V110.487L254.206 125.506Z'
      fill='#321E68'
    />
    <path
      d='M20.3801 66.0484V152.733L76.9072 140.718V155.166L6.24832 170.185V69.0523L20.3801 66.0484Z'
      fill='#FF009C'
    />
    <path
      d='M140.445 119.989L147.511 118.487V60.6972L140.445 62.1991V54.9754L112.181 60.983V68.2067L105.116 69.7086V127.499L112.181 125.997V133.22L140.445 127.213V119.989ZM154.577 44.7478V51.9716L161.643 50.4697V122.707L154.577 124.209V131.433L147.511 132.935V140.158L105.116 149.17V141.946L98.0497 143.448V136.224L90.9838 137.726V65.4887L98.0497 63.9868V56.763L105.116 55.2611V48.0374L147.511 39.026V46.2497L154.577 44.7478Z'
      fill='#FF009C'
    />
    <path
      d='M239.312 26.7367V33.9605L246.378 32.4586V46.9061L232.246 49.9099V42.6861L225.181 44.188V36.9643L196.917 42.9719V50.1956L189.851 51.6975V66.145L196.917 64.6431V71.8669L232.246 64.3574V71.5811L239.312 70.0792V77.303L246.378 75.8011V104.696L239.312 106.198V113.422L232.246 114.924V122.147L189.851 131.159V123.935L182.785 125.437V118.213L175.719 119.715V105.268L189.851 102.264V109.488L196.917 107.986V115.209L225.181 109.202V101.978L232.246 100.476V86.0286L225.181 87.5305V80.3068L189.851 87.8163V80.5925L182.785 82.0944V74.8707L175.719 76.3726V47.4776L182.785 45.9757V38.7519L189.851 37.25V30.0263L232.246 21.0149V28.2386L239.312 26.7367Z'
      fill='#FF009C'
    />
    <path
      d='M260.455 116.151V15.019L331.114 -1.34575e-05V14.4475L274.587 26.4627V55.3577L316.982 46.3463V60.7938L274.587 69.8052V98.7002L331.114 86.685V101.132L260.455 116.151Z'
      fill='#FF009C'
    />
  </svg>
);

export default SVGFightLose;
